import styled from '@emotion/styled';
import { Typography } from '@mgmresorts/mgm-ui';

import { Container } from '../../components/ui/Container';

export const StyledOuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 141px;
  max-width: 1408px;
  margin: -${({ theme }) => theme.semantic.SpaceLayoutXxl || 56}px auto ${({ theme }) =>
      theme.semantic.SpaceComponentNone}px auto;
  box-sizing: border-box;

  @media (max-width: 768px) {
    margin-top: 0;
  }
`;

export const StyledFailureCard = styled(Container)`
  margin-top: ${({ theme }) => theme.semantic.SpaceLayoutXXL || 141}px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 235px;

  @media (max-width: 768px) {
    margin-top: ${({ theme }) => theme.semantic.SpaceLayoutS || 40}px;
    margin-bottom: ${({ theme }) => theme.semantic.SpaceLayoutS || 40}px;
  }
`;

export const StyledHeading = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  text-align: center;
  width: 100%;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentS}px;

  &:focus {
    outline: none;
  }

  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  }
`;

export const StyledBody = styled(Typography)`
  text-align: center;
  margin: 0 0 ${({ theme }) => theme.semantic.SpaceComponentL}px 0;
  color: ${({ theme }) => theme.semantic.FgDefault};
  width: 100%;
  line-height: 1.5;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const StyledIconWrapper = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceLayoutXxl || 56}px;
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledIconBadge = styled.div<{ $variant: 'success' | 'error' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background-color: ${({ theme, $variant }) =>
    $variant === 'success' ? theme.semantic.SuccessSubtle || '#E6F9EF' : theme.semantic.ErrorSubtle || '#FEE6E6'};
`;

export const StyledButtonWrapper = styled.div`
  width: 100%;
  margin-top: 0;
`;

export const StyledAlertContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.semantic.SpaceLayoutXxl}px;
`;
